import React from 'react';
import Select from '../../UI/Select/Select';
import { Option } from '../../../types/common';
import type { UserData } from '../../../store/AdminUsersSlice';
import classes from './User.module.css';

interface IUserProps {
    user: UserData;
    id: string;
    lastName: string;
    firstName: string;
    middleName: string | null;
    dateOfBirth: { date: string; updatedAt: string | null } | null;
    createdAt: string | null;
    phoneNumber: string | null;
    email: string;
    emailStatus: boolean;
    card: { cardNumber: string; level: string; discount: number; balance: number } | null;
    status: 'employee' | 'customer';
    onStatusChange: (id: string, status: 'employee' | 'customer') => void;
    highlightTerm?: string;
    onRowClick?: (user: UserData) => void;
}

const statuses = [
    { id: 'base', name: 'бронзовый' },
    { id: 'silver', name: 'серебряный' },
    { id: 'gold', name: 'золотой' },
    { id: 'platinum', name: 'VIP' },
];

/* ---------- УТИЛИТА ПОДСВЕТКИ ---------- */
const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const highlight = (text: string, term: string) => {
    if (!term) return text;
    const regex = new RegExp(`(${escapeRegExp(term)})`, 'gi');
    return text.split(regex).map((part, i) =>
        part.toLowerCase() === term.toLowerCase() ? (
            <span key={i} style={{ backgroundColor: 'yellow' }}>
                {part}
            </span>
        ) : (
            part
        ),
    );
};
/* --------------------------------------- */

const User: React.FC<IUserProps> = ({
    user,
    id,
    lastName,
    firstName,
    middleName,
    dateOfBirth,
    createdAt,
    phoneNumber,
    email,
    emailStatus,
    card,
    status,
    highlightTerm = '',
    onStatusChange,
    onRowClick,
}) => {
    const options: Option[] = [
        { id: 'employee', name: 'Сотрудник' },
        { id: 'customer', name: 'Покупатель' },
    ];

    const defaultOptionText = status === 'employee' ? 'Сотрудник' : 'Покупатель';

    const handleSelect = (option: { [key: string]: string }) => {
        const newStatus = option.id as 'employee' | 'customer';
        if (newStatus !== status) {
            onStatusChange(id, newStatus);
        }
    };

    const cardLevelObj = card?.level ? statuses.find((s) => s.id === card.level) : undefined;
    const cardLevelName = card?.level ? (cardLevelObj ? cardLevelObj.name : card.level) : '-';

    const term = highlightTerm.trim();

    const handleRowClick = () => {
        if (onRowClick) {
            onRowClick(user);
        }
    };

    return (
        <>
            <tr className={classes['user-row']} onClick={handleRowClick}>
                <td className={classes['user-cell']}>{highlight(`${lastName} ${firstName} ${middleName ?? ''}`, term)}</td>
                <td
                    className={classes['user-cell']}
                    title={dateOfBirth?.updatedAt ? `Дата установки: ${new Date(dateOfBirth.updatedAt).toLocaleDateString('ru-RU')}` : ''}
                >
                    {dateOfBirth?.date || '-'}
                </td>
                <td className={classes['user-cell']}>{createdAt ? new Date(createdAt).toLocaleDateString('ru-RU') : '-'}</td>
                <td className={classes['user-cell']}>{highlight(phoneNumber ?? '-', term)}</td>
                <td
                    style={{ color: emailStatus ? 'inherit' : 'red', cursor: 'default' }}
                    className={classes['user-cell']}
                    title={emailStatus ? 'подтверждён' : 'не подтверждён'}
                >
                    {email || '-'}
                </td>
                <td className={classes['user-cell']}>{cardLevelName}</td>
                <td className={classes['user-cell']} onClick={(e) => e.stopPropagation()}>
                    <Select
                        options={options}
                        defaultOptionText={defaultOptionText}
                        value={defaultOptionText}
                        label="Статус"
                        field="status"
                        onSelect={handleSelect}
                    />
                </td>
                <td className={classes['user-cell']} onClick={(e) => e.stopPropagation()}>
                    {/* кнопка редактирования в будущем */}
                </td>
            </tr>
        </>
    );
};

export default User;
